import AllStaffHistoryContainer from "./AllStaffHistoryContainer"

const AllStaffs = () => {
  return (
      <div className='page-body'>
          <AllStaffHistoryContainer />
      </div>
  )
}

export default AllStaffs